import * as t from 'io-ts';
import { optional } from './helper';

const rugbyLogs = t.type({
  GroupName: optional(t.string),
  GroupShortName: optional(t.string),
  LogName: optional(t.string),
  LeagueName: optional(t.string),
  Team: optional(t.string),
  TeamID: optional(t.string),
  Position: t.number,
  Played: t.number,
  Won: t.number,
  Drew: t.number,
  Lost: t.number,
  PointsFor: t.number,
  PointsAgainst: t.number,
  BonusPoints: t.number,
  PointsDifference: t.number,
  Points: t.number,
  Sport: t.number,
  rank: t.number,
  ConferenceRank: t.number,
  CombinedRank: t.number,
  HomeGroup: optional(t.string),
  IsConference: t.number,
  TriesFor: t.number,
  TriesAgainst: t.number,
  TriesBonusPoints: t.number,
  LossBonusPoints: t.number,
});
export type RugbyLogs = t.TypeOf<typeof rugbyLogs>;

const matchTeamStatistics = t.type({
  Tries: t.number,
  Conversions: t.number,
  ConversionsMissed: t.number,
  Penalties: t.number,
  PenaltiesMissed: t.number,
  DropGoals: t.number,
  DropGoalsMissed: t.number,
  ConversionAttempts: t.number,
  PenaltyAttempts: t.number,
  DropGoalAttempts: t.number,
  DefendersBeaten: t.number,
  Offloads: t.number,
  LineOutsWon: t.number,
  LineOutsLost: t.number,
  PenaltiesConceded: t.number,
  Tackles: t.number,
  Territory: t.number,
  Passes: t.number,
  CleanBreaks: t.number,
  ScrumsWon: t.number,
  MissedTackles: t.number,
  Possession: t.number,
  CarriesCrossedGainLine: t.number,
  ScrumsLost: t.number,
  PenaltyTries: t.number,
  YellowCards: t.number,
  RedCards: t.number,
});
export type MatchTeamStatistics = t.TypeOf<typeof matchTeamStatistics>;

const events = t.type({
  Comments: optional(t.string),
  DisplayTime: optional(t.string),
  EventId: optional(t.number),
  EventName: optional(t.string),
  ExtendTime:  optional(t.number),
  Id: optional(t.number),
  MatchId: optional(t.number),
  Player1DisplayName: optional(t.string),
  Player1FullName: optional(t.string),
  Player1Id: optional(t.number),
  Player1Surname: optional(t.string),
  Player2DisplayName: optional(t.string),
  Player2FullName: optional(t.string),
  Player2Id: optional(t.number),
  Player2Surname: optional(t.string),
  TeamId: optional(t.number),
  Time: optional(t.number),
});
export type Events = t.TypeOf<typeof events>;

const teamSheet = t.type({
  Number: t.number,
  PositionName: t.string,
  IsSubstitute: t.boolean,
  IsUsedSubstitute: t.boolean,
  IsCaptain: t.boolean,
  TeamId: t.number,
  PersonId: t.number,
  Name: t.string,
  Surname: t.string,
  DisplayName: t.string,
});
export type TeamsSheet = t.TypeOf<typeof teamSheet>;

const teamScorers = t.type({
  Type: t.string,
  EventId: t.number,
  Time: t.number,
  PersonId: t.number,
  Name: t.string,
  Surname: t.string,
  DisplayName: t.string,
});
export type TeamsScorers= t.TypeOf<typeof teamScorers>;

export const rugbyMatchDetail = t.type({
  MatchStatisticsTeamA: matchTeamStatistics,
  MatchStatisticsTeamB: matchTeamStatistics,
  LeagueName: t.string,
  LeagueId: t.number,
  LeagueUrlName: t.string,
  IsPlaceholderTeamA: optional(t.boolean),
  IsPlaceholderTeamB: optional(t.boolean),
  TeamAName: optional(t.string),
  TeamBName: optional(t.string),
  TeamAShortName: optional(t.string),
  TeamBShortName: optional(t.string),
  TeamAId: t.number,
  TeamBId: t.number,
  KickoffDateTime: optional(t.string),
  Location: optional(t.string),
  Status: t.string,
  MatchCompleted: optional(t.boolean),
  TeamAScore: t.number,
  TeamBScore: t.number,
  RoundNumber: optional(t.number),
  MatchNumber: optional(t.number),
  ManOfTheMatch: optional(t.string),
  ManOfTheMatchId: optional(t.number),
  Events: t.array(events),
  Teamsheet: t.array(teamSheet),
  TeamATeamsheet: t.array(teamSheet),
  TeamBTeamsheet: t.array(teamSheet),
  TeamAScorers: t.array(teamScorers),
  TeamBScorers: t.array(teamScorers),
  postponed: optional(t.boolean),
  matchTime: optional(t.string),
});
export type RugbyMatchDetail = t.TypeOf<typeof rugbyMatchDetail>;

export const rugbyLogsApiResponse = t.array(rugbyLogs);
export type RugbyTable = t.TypeOf<typeof rugbyLogsApiResponse>;
